import { Box, Paper, Typography } from '@mui/material'
import { AsyncActionButton } from '@src/components'
import { useDownloadMerchDbAccessReport } from '@src/data/api/merchants-api/merchants-api'
import { useTranslation } from 'react-i18next'

const MerchDbAccessReport = () => {
  const { t } = useTranslation()
  const [downloadReport, isDownloading] = useDownloadMerchDbAccessReport()

  return (
    <Box sx={{ height: '100%', width: '100%', p: 3 }}>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">{t('common.merchDbAccess')}</Typography>
          <AsyncActionButton
            variant="contained"
            color="primary"
            onClick={() => downloadReport()}
            isPending={isDownloading}
          >
            {t('common.download')}
          </AsyncActionButton>
        </Box>
      </Paper>
    </Box>
  )
}

export default MerchDbAccessReport
